import { createRouter, createWebHistory, RouteLocationNormalized } from "vue-router";
import { TasksRoutes, AuthRoutes, DashboardRoutes } from "./routes";
import { getTokenFromLocalStorage } from "@/utils/v2";
import { useUsersStore } from "@/stores/v2";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...AuthRoutes, ...DashboardRoutes, ...TasksRoutes],
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next) => {
  const pageTitle = to.meta.title as string | undefined;

  document.title = pageTitle
    ? `${process.env.APP_NAME ?? ""} ${pageTitle}`
    : process.env.APP_NAME ?? "";

  next();
});

router.beforeEach((to, from, next) => {
  const userStore = useUsersStore();
  const token = getTokenFromLocalStorage();
  const isLoggedIn = userStore.isLoggedIn && !!token;

  // Public routes
  const publicRoutes = ["/", "/login", "/register"];

  if (!isLoggedIn && !publicRoutes.includes(to.path)) {
    // Redirect to login page if not authenticated
    next("/");
  } else {
    next();
  }
});

export default router;
